import { Component, Input, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ApiRequestsService } from '@base/api/api.gateway';
import { ProjectsService } from '@eyrus/shared/services';

@Component({
  selector: 'dailylog-complete-day-content',
  templateUrl: './complete-day.component.html',
  styleUrls: ['./complete-day.component.sass']
})

export class DailyCompleteDayContent {

  public loading = false;

  @Input() contractId;
  @Input() calendarDate;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private api: ApiRequestsService,
    private projectService: ProjectsService
  ) { }


  ngOnInit() {

  }

  public completeDaily() {

    if(this.loading) return;
    this.loading = true;

    const payload = {
      calendarDate: this.calendarDate
    };

    this.api.dailyLogs.completeDay(this.contractId, payload)
      .then(result => {
        this.activeModal.close(result);
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
      });
  }




}